<section class="login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-8 col-lg-8">
        <div class="login-box">
          <h3 style="text-align: center; font-weight:bold; margin-bottom:20px;">Inscription</h3>

          <div style="margin: auto;">
            <p class="rad">Choisissez votre profile :</p>

            <div class="form-check rad">
              <input type="radio" class="form-check-input" id="candidat" name="typeuser" value="candidat" checked
                (click)="choiceProfile('candidat')">
              <label for="candidat" class="form-check-label" (click)="choiceProfile('candidat')">CANDIDAT</label>

            </div>

            <div class="form-check rad">
              <input type="radio" class="form-check-input" id="consultant" name="typeuser" value="consultant"
                (click)="choiceProfile('consultant')">
              <label for="consultant" class="form-check-label" (click)="choiceProfile('consultant')">CONSULTANT</label>
            </div>

            <div class="form-check rad">
              <input type="radio" class="form-check-input" id="entreprise" name="typeuser" value="entreprise"
                (click)="choiceProfile('entreprise')">
              <label for="entreprise" class="form-check-label" (click)="choiceProfile('entreprise')">ENTREPRISE</label>

            </div>
          </div>
          <!-- Candidat form -->
          <div class="row d-flex justify-content-center" *ngIf="typeUser == 'candidat'">
            <form class="" style="margin-top: 20px;" [formGroup]="candidatForm" (ngSubmit)="onSubmitForm(typeUser)">
              <div style="margin-top: -5px; margin-bottom: 10px;">
                Les champs avec <strong style="color: red">**</strong> sont obligatoires.
              </div>
              <div class="row">
                <div class="mb-3 col-md-6">
                  <select id="gender" formControlName="gender" class="form-control form-select form-select-sm"
                    aria-label=".form-select-lg example">
                    <option selected="">Genre*</option>
                    <option value="Homme">Homme</option>
                    <option value="Femme">Femme</option>
                  </select>
                </div>
                <div class="mb-3 col-md-6">
                  <input type="text" class="form-control" id="lastName" formControlName="lastName" placeholder="Nom**">
                </div>
                <div class="mb-3 col-md-6">
                  <input type="text" class="form-control" id="firstName" formControlName="firstName"
                    placeholder="Prénom**">
                </div>
                <div class="mb-3 col-md-6">
                  <input type="text" class="form-control" id="phone_1_candidat" formControlName="phone1"
                    placeholder="Téléphone**">
                </div>
                <div class="mb-3 col-md-6">
                  <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example"
                    id="country" formControlName="country" (ngModelChange)="onChangeCountry($event)">
                    <option selected="">Pays*</option>
                    <option [value]="country" *ngFor="let country of countryList">{{ country }}</option>
                  </select>
                </div>
                <div class="mb-3 col-md-6">
                  <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example" id="city"
                    formControlName="city">
                    <option selected="">Ville*</option>
                    <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                  </select>
                </div>
                <div class="mb-3 col-md-6">
                  <input type="email" class="form-control" id="email" style="text-transform: lowercase !important;"
                    formControlName="email" placeholder="Email**">
                </div>
                <div class="mb-3 col-md-6">
                  <input type="password" class="form-control" id="password" formControlName="password"
                    placeholder="Mot de passe**">
                </div>
                <div class="mb-3 col-md-12" style="margin: 10px 0px 10px;">

                  <a href="" style="font-size: 13px; color: #FF5A00; float: right; ">Mot de passe oublié ?</a>
                </div>
                <div class="mb-3 col-md-12">
                  <button type="submit" class="btn btn-submit" [disabled]="candidatForm.invalid"
                    *ngIf="!isLoading">Créer mon
                    compte</button>
                  <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">
                    Veuillez patienter...</p>
                </div>
                <div class="col-md-12" style="margin: 20px 0px 0px; text-align: center;">
                  <span style="color: #000;font-size: 12px;">Avez-vous déjà un compte?
                    <a [routerLink]="['/connexion']" style="color: #FF5A00;">Connectez-vous</a></span>
                </div>
              </div>

            </form>
          </div>
          <!-- Consultant form -->
          <div class="row d-flex justify-content-center" *ngIf="typeUser == 'consultant'">
            <form class="row" style="margin-top: 20px;" [formGroup]="consultantForm"
              (ngSubmit)="onSubmitForm(typeUser)">
              <div style="margin-top: -5px; margin-bottom: 10px;">
                Les champs avec <strong style="color: red">**</strong> sont obligatoires.
              </div>
              <div class="mb-3 col-md-6">
                <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example"
                  id="gender_consultant" formControlName="gender">
                  <option selected="">Genre*</option>
                  <option value="Homme">Homme</option>
                  <option value="Femme">Femme</option>
                </select>
              </div>

              <div class="mb-3 col-md-6">
                <input type="text" class="form-control" id="last_name_consultant" formControlName="last_name"
                  placeholder="Nom**">
              </div>

              <div class="mb-3 col-md-6">
                <input type="text" class="form-control" id="first_name_consultant" formControlName="first_name"
                  placeholder="Prénom**">
              </div>

              <div class="mb-3 col-md-6">
                <input type="text" class="form-control" id="phone_1_consultant" formControlName="phone_1"
                  placeholder="Téléphone**">
              </div>
              <div class="mb-3 col-md-6">
                <input type="email" class="form-control" style="text-transform: lowercase !important;"
                  id="email_consultant" formControlName="email" placeholder="Email**">
              </div>

              <div class="mb-3 col-md-6">
                <input type="password" class="form-control" id="password_consultant" formControlName="password"
                  placeholder="Mot de passe**">
              </div>
              <div class="mb-3 col-md-12" style="margin: 10px 0px 10px;">

                <a href="" style="font-size: 13px; color: #FF5A00; float: right; ">Mot de passe oublié ?</a>
              </div>

              <div class="mb-3 col-md-12">
                <button type="submit" class="btn btn-submit" [disabled]="consultantForm.invalid"
                  *ngIf="!isLoading">Créer mon
                  compte</button>
                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">
                  Veuillez patienter...</p>
              </div>

              <div class="col-md-12" style="margin: 20px 0px 0px; text-align: center;">
                <span style="color: #000;font-size: 12px;">Vous avez déjà un compte ?
                  <a [routerLink]="['/connexion']" style="color: #FF5A00;">Connectez-vous</a></span>
              </div>

            </form>
          </div>

          <!-- Company form -->
          <div class="row d-flex justify-content-center" *ngIf="typeUser == 'entreprise'">
            <form class="row" style="margin-top: 20px;" [formGroup]="companyForm" (ngSubmit)="onSubmitForm(typeUser)">
              <div class="mb-3 col-md-6">
                <input type="text" class="form-control" id="name" formControlName="name"
                  placeholder="Nom de l'entreprise**">
              </div>

              <div class="mb-3 col-md-6">
                <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example"
                  id="areaActivity" formControlName="area_activity_id">
                  <option selected="">Secteur d'activité**</option>
                  <option [value]="areaActivity.id" *ngFor="let areaActivity of areaActivityList">{{
                    areaActivity.libelle }}</option>
                </select>
              </div>

              <div class="mb-3 col-md-6">
                <input type="text" class="form-control" id="acronym" formControlName="acronym" placeholder="SIGLE">
              </div>


              <div class="mb-3 col-md-6">
                <input type="text" class="form-control" id="phone_1" formControlName="phone_1"
                  placeholder="Téléphone**">
              </div>

              <div class="mb-3 col-md-6">
                <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example"
                  id="country_company" formControlName="country">
                  <option selected="">Pays*</option>
                  <option [value]="country" *ngFor="let country of countryList">{{ country }}</option>
                </select>
              </div>

              <div class="mb-3 col-md-6">
                <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example"
                  id="city_company" formControlName="city">
                  <option selected="">Ville*</option>
                  <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                </select>
              </div>
              <div class="mb-3 col-md-6">
                <input type="text" class="form-control" id="address_company" formControlName="address"
                  placeholder="Adresse**">
              </div>

              <div class="mb-3 col-md-6">
                <select class="form-control form-select form-select-sm" aria-label=".form-select-lg example"
                  id="nb_person" formControlName="nb_person">
                  <option selected="">Nombre d'employés*</option>
                  <option value="1 à 5">1 à 5</option>
                  <option value="6 à 10">6 à 10</option>
                  <option value="10 à 50">10 à 50</option>
                  <option value="Plus de 50">Plus de 50</option>
                </select>
              </div>
              <div class="mb-3 col-md-6">
                <input type="email" class="form-control" id="email_company" formControlName="email"
                  placeholder="Email**">
              </div>

              <div class="mb-3 col-md-6">
                <input type="password" class="form-control" id="password_company" formControlName="password"
                  placeholder="Mot de passe**">
              </div>
              <div class="mb-3 col-md-12" style="margin: 10px 0px 10px;">

                <a href="" style="font-size: 13px; color: #FF5A00; float: right; ">Mot de passe oublié ?</a>
              </div>

              <div class="mb-3 col-md-12">
                <button type="submit" class="btn btn-submit" [disabled]="companyForm.invalid" *ngIf="!isLoading">Créer
                  mon
                  compte</button>
                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">
                  Veuillez patienter...</p>
              </div>

              <div class="col-md-12" style="margin: 20px 0px 0px; text-align: center;">
                <span style="color: #000;font-size: 12px;">Vous avez déjà un compte ?
                  <a [routerLink]="['/connexion']" style="color: #FF5A00;">Connectez-vous</a></span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>